import React from 'react';
import { ThemeProvider } from './context/themeContext';
import { ToastProvider } from './context/toastContext';
import { ConfirmProvider } from './context/confirmContext';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
    <ToastProvider>
    <ConfirmProvider>
    <App />
    </ConfirmProvider>
    </ToastProvider>
    </ThemeProvider> 
  </React.StrictMode>
);

reportWebVitals();
